import { render } from "./DetalharSubconta.vue?vue&type=template&id=c8815c66&scoped=true"
import script from "./DetalharSubconta.vue?vue&type=script&lang=js"
export * from "./DetalharSubconta.vue?vue&type=script&lang=js"

import "./DetalharSubconta.vue?vue&type=style&index=0&id=c8815c66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8815c66"]])

export default __exports__